var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeDownActivated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3254 2.26445C15.2694 1.7325 16.619 2.02641 17.4958 2.9365C17.8705 3.30357 18.1154 4.06899 18.1638 4.53097C18.7225 4.89703 19.384 5.63632 19.4418 7.02655C20.4387 7.75771 21.1961 9.10951 20.2504 11.0864C20.7995 11.6267 21.4124 13.275 20.6248 14.6029C19.7072 16.1552 17.7125 16.2631 15.7248 15.9861C16.2551 17.5513 16.4539 18.9956 15.615 20.4748C14.7807 21.787 13.6288 22 13.2349 22C12.1574 21.9998 11.4186 21.0206 11.1194 19.7166C11.0105 19.3525 10.8864 18.4932 10.8381 18.2668C10.5872 16.8266 9.74319 15.6745 8.30949 14.8133C8.04555 14.6532 7.77547 14.5052 7.50002 14.3695V3.88022C8.65196 3.5994 9.80116 3.30217 10.9462 2.98711C12.1857 2.63407 12.458 2.51648 13.3254 2.26445Z",
    fill: "url(#paint0_linear_237_8580)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70001 13.867H4.0837C3.59034 13.8669 3.00001 13.3394 3 12.7013V5.06453C3.07006 4.34254 3.44997 3.98245 4.13819 3.98232H5.70001V13.867Z",
    fill: "url(#paint1_linear_237_8580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_8580",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#825AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D73E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_237_8580",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#825AE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D73E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDownActivated);
export default __webpack_public_path__ + "static/media/like_down_activated.d2d2e99ee49adc5ea83d5bed0b057764.svg";
export { ForwardRef as ReactComponent };